import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'myTruncate',
  standalone: false
})
export class TruncatePipe implements PipeTransform {
  public transform(value: string, limit: number): string {
    limit = limit ? limit : 30;
    let trail = '...';
    if (value && value.length > limit) {
      return value.substring(0, limit) + trail;
    } else {
      return value;
    }
  }
}
